export default __webpack_public_path__ + "static/head_cash_in_t.png";